import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "aero-score-wrapper" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "indicator" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "score" }, "A", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "score" }, "B", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "score" }, "C", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "score" }, "D", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "score" }, "E", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "aero-values" }
const _hoisted_15 = { class: "value-description" }
const _hoisted_16 = { class: "icon-wrapper mr-1" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    empty: !_ctx.stats || !_ctx.score,
    title: _ctx.$t('dashboard.aero_score_widget.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('dashboard.aero_score_widget.description')), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["center indicator-segment bg-a", {'is-active': _ctx.score === 'A'}])
          }, _hoisted_5, 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["center indicator-segment bg-b", {'is-active': _ctx.score === 'B'}])
          }, _hoisted_7, 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["center indicator-segment bg-c", {'is-active': _ctx.score === 'C'}])
          }, _hoisted_9, 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["center indicator-segment bg-d", {'is-active': _ctx.score === 'D'}])
          }, _hoisted_11, 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["center indicator-segment bg-e", {'is-active': _ctx.score === 'E'}])
          }, _hoisted_13, 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", { src: _ctx.icon }, null, 8 /* PROPS */, _hoisted_17)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(`aero-color-${_ctx.score?.toLocaleLowerCase()}`)
            }, _toDisplayString(_ctx.label), 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.range), 1 /* TEXT */)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["widget", "mode", "empty", "title"]))
}